module.exports = __webpack_public_path__ + "img/banner-1-m.e51bee4e.jpg";